import { motion } from "framer-motion";
import Translate from "./Translate";

const Switch = ({ items, activedIndex, size, onClick }) => {
  const sizeClasses = {
    sm: "h-[40px]",
    md: "h-[50px]",
    lg: "h-[60px]",
  };

  return (
    <div
      className={`relative w-full ${sizeClasses[size]} flex p-1 bg-[#1C1C1C] rounded-3xl overflow-hidden`}
    >
      {items.map((item, index) => {
        const isActive = activedIndex === index;
        return (
          <button
            key={index}
            type="button"
            onClick={() => onClick(index)}
            className={`flex-1 h-full rounded-3xl flex items-center justify-center text-sm font-semibold transition-colors duration-300 cursor-pointer select-none
              ${
                isActive
                  ? "text-white bg-gradient-to-r from-[#C427E0] via-[#12A9FF] to-[#844AFF]"
                  : "text-white/50 bg-transparent"
              }
            `}
            style={{
              background: isActive
                ? "linear-gradient(90deg, rgba(196,39,224,1) 0%, rgba(18,169,255,1) 38%, rgba(132,74,255,1) 100%)"
                : undefined,
            }}
          >
            <Translate>{item}</Translate>
          </button>
        );
      })}
    </div>
  );
};

export default Switch;
